// @flow

import { css } from "styled-components";

const lineStyle = css`
  background-color: ${({ theme }) => theme.palette.hague30};
  border: 0;
  height: 1px;
  margin: 0;
  width: 100%;
`;

export const HorizontalLine = () => <hr css={lineStyle} />;
